import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section className="bg-dark py-32 border-t border-dark-border" data-id="element-31">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-32">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-33">
          <h2 className="font-display text-4xl md:text-6xl font-bold text-white mb-10 uppercase leading-tight" data-id="element-34">
            ¿Cuánto vale tu relación con tu pareja? ¿Tu orgullo, tu confianza,
            tu tiempo?
          </h2>

          <p className="text-2xl text-accent font-bold mb-12" data-id="element-35">
            Más de $17, apuesto.
          </p>

          <div className="flex flex-col items-center gap-6" data-id="element-36">
            <div className="flex items-center gap-4" data-id="element-37">
              <span className="text-gray-500 line-through text-2xl font-bold" data-id="element-38">
                $27
              </span>
              <span className="text-white font-bold text-5xl" data-id="element-39">$17</span>
            </div>

            <motion.button whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="bg-accent hover:bg-accent-hover text-white font-bold py-6 px-12 rounded-lg text-2xl w-full sm:w-auto shadow-[0_0_40px_rgba(255,77,26,0.4)] transition-all uppercase tracking-wide" data-id="element-40">
              CONSIGUE EL EBOOK AHORA →
            </motion.button>

            <p className="text-accent/80 font-medium text-sm uppercase tracking-widest mt-4" data-id="element-41">
              La adicción a la pornografía solo empeora con el tiempo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}